export default {
  set(state, { data }) {
    state.vmPrices = data;
  },
  show(state, { data }) {
    state.vmPrice = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}